import { useState } from 'react';
import './testimonialCard.css';

const VerifiedBadge = () => (
  <svg viewBox="0 0 24 24" width="19" height="19" aria-label="Verified Google Review" style={{ flexShrink: 0 }}>
    {/* Google-style shield badge */}
    <path
      fill="#1a73e8"
      d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
    />
    {/* White checkmark */}
    <path
      fill="#fff"
      d="M10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    />
  </svg>
);

const GoogleGIcon = () => (
  <svg viewBox="0 0 48 48" width="22" height="22" className="google-g-icon" aria-label="Google">
    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/>
    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/>
    <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z"/>
    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"/>
  </svg>
);

const MAX_CHARS = 130;

export default function TestimonialCard({ name, description, rating, date, avatarColor, profilePhotoUrl }) {
  const [photoError, setPhotoError] = useState(false);
  const [expanded, setExpanded]     = useState(false);

  const initial    = name ? name.charAt(0).toUpperCase() : '?';
  const showPhoto  = profilePhotoUrl && !photoError;
  const isLong     = description.length > MAX_CHARS;
  const displayText = isLong && !expanded
    ? description.slice(0, MAX_CHARS).trimEnd() + '...'
    : description;

  return (
    <div className="testimonial-card">
      <div className="card-header">
        {showPhoto ? (
          <img
            src={profilePhotoUrl}
            alt={name}
            className="reviewer-avatar reviewer-avatar-photo"
            onError={() => setPhotoError(true)}
          />
        ) : (
          <div className="reviewer-avatar" style={{ backgroundColor: avatarColor }}>
            {initial}
          </div>
        )}

        <div className="reviewer-info">
          <h3 className="reviewer-name">{name}</h3>
          <span className="review-date">{date}</span>
        </div>

        <GoogleGIcon />
      </div>

      <div className="card-stars-row">
        <span className="card-stars">{'★'.repeat(rating)}</span>
        <VerifiedBadge />
      </div>

      <p className="review-body">{displayText}</p>

      {isLong && (
        <button className="read-more-btn" onClick={() => setExpanded(e => !e)}>
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  );
}
